import { FREE_DELIVERY_ZONES_MO } from './config';

function normalizeCityName(v: unknown): string {
    return String(v || '').trim();
}
function normalizeRegionName(v: unknown): string {
    return String(v || '').trim();
}

export function isFreeDeliveryZoneAddress(authUser: any): boolean {
    const region = normalizeRegionName(authUser?.address?.struct?.region);
    const city = normalizeCityName(authUser?.address?.struct?.city);
    if (region === 'Москва' && city === 'Москва') return true;
    if (region === 'Москва' && city === 'Зеленоград') return true;
    if (region === 'Москва' && city === 'Коммунарка') return true;
    if (region === 'Москва' && city === 'Троицк') return true;
    if (region === 'Московская' && FREE_DELIVERY_ZONES_MO.has(city)) return true;
    return false;
}
